import { render, staticRenderFns } from "./DateTimeOfLesson.vue?vue&type=template&id=c0251644&scoped=true"
import script from "./DateTimeOfLesson.vue?vue&type=script&lang=js"
export * from "./DateTimeOfLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0251644",
  null
  
)

export default component.exports